import BaseClient from '@/app/model/api/response/baseApiClient'

class AiAdviceDetailApi extends BaseClient {
  public getAiAdviceDetail (id: string) {
    const path = '/v1/ai-advice/' + id
    const url = new URL(process.env.VUE_APP_API_URL + path)

    /* 共通処理 */
    return super.doFetch(decodeURI(url.href), 'GET')
  }
}

export default new AiAdviceDetailApi()
